import { coberturaEquipoEspecial, planes } from "../data/Data";
import { endPoints } from "../../../utils/constanst";
import { round } from "../../../utils/helpers";
import http from "../../../services/http";
import { getResumen } from "../../../services/tarificar";

const tarificar = planId => data => {

    return new Promise((resolve, reject) => {

        http(endPoints.tarificar(planId)).post(data).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });

    })

    const getResumen = (tarifas = []) => {

        if (tarifas.length === 0) return 0;
    
        return tarifas.map(x => ({ ...x, prima: round(x.prima) + round((x.prima * x.pRecargo) / 100) })).sum('prima');
    
    }

}

export{getResumen};

export default tarificar;
